import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  LecBankAccount,
  LecBankAccountFilters
} from '../../lib/types/models/lec-bank-account/lec-bank-account'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getLecBankAccounts(input?: PaginationRequest<LecBankAccountFilters>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<LecBankAccountFilters>>(
        API.lecBankAccounts.getAll.url,
        input
      )
    )
    .get<PaginationResponse<LecBankAccount>>()
}
